import { GET_ATTACHMENTS_REQUEST } from "../action.types";
import initialValue from "../initial.state";

export default function(state = initialValue.file, action) {
  switch (action.type) {
    // case GET_ATTACHMENTS_REQUEST:
    //   return state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/file/file.reducer.js